module.exports = __webpack_public_path__ + "system/img/def1.2c3d4696.png";